import { filter } from 'ramda';

import { Report } from '@/shared/api/protocol-ts/model/dto_report_pb';

import { isReportIncludesStudyID } from './isReportIncludesStudyID';

export const filterReportByStudyID = (reports: Report[], studyID: string) =>
  filter<Report>(isReportIncludesStudyID(studyID))(reports);
